import { render, staticRenderFns } from "./ptStrategyAdd.vue?vue&type=template&id=10550553&scoped=true"
import script from "./ptStrategyAdd.vue?vue&type=script&lang=js"
export * from "./ptStrategyAdd.vue?vue&type=script&lang=js"
import style0 from "./ptStrategyAdd.vue?vue&type=style&index=0&id=10550553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10550553",
  null
  
)

export default component.exports